import React, { useState } from "react";

// ASSETS
import { ReactComponent as Graphic } from "assets/svg/Graphic.svg";

// STYLES
import {
  CardWrapper,
  IconWrapper,
  TextWrapper,
  IframeWrapper,
  RowWrapper,
} from "./StatisticCardStyled";

// LIBRARIES
import Skeleton from "react-loading-skeleton";

// MISC
import { IProps } from "./StatisticCardModel";
import { TextType } from "../CustomText/CustomTextModel";
import { BORDER_RADIUS, COLORS, SIZE } from "constants/variables";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "../CustomText/CustomText";

const StatisticCard = (props: IProps) => {
  // PROPERTIES
  const { antet = "STATISTICI", title = "", href = "" } = props;

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const isLoading = !title;
  const [showIframe, setShowIframe] = useState(true); // State to toggle iframe

  // EVENT HANDLERS
  const handleCardClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault(); // Prevent link from opening a new tab
    setShowIframe(true); // Show iframe when card is clicked
  };
  
  // <iframe width="390" height="8750" src="https://lookerstudio.google.com/embed/reporting/a3e9ea3b-65f6-496f-8945-4032ba33ee1c/page/p_mnockd85dd" ></iframe>
  // console.log(
  //   href ==
  //     "https://lookerstudio.google.com/embed/reporting/a3e9ea3b-65f6-496f-8945-4032ba33ee1c/page/p_mnockd85dd"
  // );
  // console.log("href", typeof href);

  return (
    <>
      {!isLoading ? (
        <RowWrapper>
          <CardWrapper
            biggerCursor={biggerCursor}
            onClick={handleCardClick} // Trigger the iframe display
          >
            <TextWrapper>
              <CustomText
                text={antet}
                type={TextType.H6}
                color={COLORS.VividAuburn}
              />
            </TextWrapper>
            <TextWrapper>
              <CustomText
                text={title}
                type={TextType.H4}
                color={COLORS.RaisinBlack}
              />
            </TextWrapper>
            <IconWrapper>
              <Graphic />
            </IconWrapper>
          </CardWrapper>

          {showIframe && (
            <IframeWrapper>
              <iframe
                src={href}
                sandbox="allow-same-origin allow-scripts allow-popups"
                loading="lazy"
              />
            </IframeWrapper>
          )}
        </RowWrapper>
      ) : (
        <CardWrapper>
          <Skeleton height={SIZE.max24} width={120} />
          <Skeleton height={SIZE.max78} width={120} />
        </CardWrapper>
      )}
    </>
  );
};

export default StatisticCard;
